import axios from 'axios';

import cfac22 from '../cfac22';

export async function getWallet_v1(uId, triiboId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        cfac22('API_HOST_V2') + '/wallet/get',
        {
          triiboId
        },
        {
          headers: {

            'Content-Type': 'application/json',
            'Full-Url': window.location.href
          }, withCredentials: true
        }
      ).
      then((result) => {
        const wallet = {
          coupons: result.data.result.wallet,
          totalPoints: result.data.result.totalPoints
        };

        resolve(wallet);
      }).
      catch((error) => {
        reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
